package io.horion.cv.api.repository.letter

import io.horion.cv.api.config.HttpClient.client
import io.horion.cv.api.datasource.Endpoint
import io.horion.cv.api.datasource.common.Generate
import io.horion.cv.api.datasource.motivation.Letter
import io.horion.cv.api.datasource.motivation.ModelLetter
import io.horion.cv.api.datasource.response.Response
import io.horion.cv.api.utils.Constants.CV_API_URL
import io.ktor.client.call.body
import io.ktor.client.request.accept
import io.ktor.client.request.get
import io.ktor.client.request.headers
import io.ktor.client.request.parameter
import io.ktor.client.request.delete
import io.ktor.client.request.post
import io.ktor.client.request.put
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.http.contentType

class LetterRepositoryImpl: LetterRepository {

    override suspend fun createLetter(token: String, model : ModelLetter, letter: Letter): Response? {
        val response : HttpResponse = client.post("$CV_API_URL${Endpoint.MotivationGenerate.path}") {
            contentType(ContentType.Application.Json)
            url {
                parameter("model", model.name)
            }
            headers {
                append(HttpHeaders.Authorization, "Bearer $token")
            }
            setBody(letter)
            accept(ContentType.Application.Json)
        }
        return when (response.status) {
            HttpStatusCode.OK,
            HttpStatusCode.BadRequest -> {
                response.body<Response>()
            }
            HttpStatusCode.Unauthorized -> {
                null
            }
            else ->
                Response(
                    success = false,
                    message = "Erreur serveur (${response.status})"
                )
        }
    }

    override suspend fun insertLetter(token: String,letter: Letter): Response? {
        val response : HttpResponse = client.post("$CV_API_URL${Endpoint.Motivation.path}") {
            contentType(ContentType.Application.Json)
            accept(ContentType.Application.Json)
            headers {
                append(HttpHeaders.Authorization, "Bearer $token")
            }
            setBody(letter)
        }
        return when (response.status) {
            HttpStatusCode.OK,
            HttpStatusCode.BadRequest -> {
                response.body<Response>()
            }
            HttpStatusCode.Unauthorized -> {
                null
            }
            else ->
                Response(
                    success = false,
                    message = "Erreur serveur (${response.status})"
                )
        }
    }

    override suspend fun deleteLetter(token: String, letterId: String): Response? {
        return try {
            val response: HttpResponse = client.delete("$CV_API_URL${Endpoint.DeleteMotivation.path}") {
                contentType(ContentType.Application.Json)
                url { parameter("id", letterId) }
                headers {
                    append(HttpHeaders.Authorization, "Bearer $token")
                }
                accept(ContentType.Application.Json)
            }

            when (response.status) {
                HttpStatusCode.OK -> response.body<Response>()
                HttpStatusCode.Unauthorized -> null
                else -> Response(false, "Erreur serveur (${response.status})")
            }
        } catch (e: Exception) {
            Response(false, e.message ?: "Erreur réseau")
        }
    }

    override suspend fun checkLetterById(token: String, id: String): Letter? {
        return try {
            val response: HttpResponse = client.get("$CV_API_URL${Endpoint.FindMotivationById.path}") {
                contentType(ContentType.Application.Json)
                url { parameter("id", id) }
                headers {
                    append(HttpHeaders.Authorization, "Bearer $token")
                }
                accept(ContentType.Application.Json)
            }

            when (response.status) {
                HttpStatusCode.OK -> response.body<Letter>()
                else -> null
            }
        } catch (e: Exception) {
            null
        }
    }

    override suspend fun updateLetter(token: String, letter: Letter, model: String?): Response? {
        return try {
            val response: HttpResponse = client.put("$CV_API_URL${Endpoint.UpdateMotivation.path}") {
                contentType(ContentType.Application.Json)
                url { if (model != null) parameter("model", model) }
                headers {
                    append(HttpHeaders.Authorization, "Bearer $token")
                }
                accept(ContentType.Application.Json)
                setBody(letter)
            }

            when (response.status) {
                HttpStatusCode.OK,
                HttpStatusCode.BadRequest -> response.body<Response>()
                HttpStatusCode.Unauthorized -> null
                else -> Response(false, "Erreur serveur (${response.status})")
            }
        } catch (e: Exception) {
            Response(false, "Erreur: ${e.message}")
        }
    }

    override suspend fun checkHistory(token: String, refresh: Boolean): List<Generate>? {
        return try {
            val response : HttpResponse = client.get("$CV_API_URL${Endpoint.HistoryMotivation.path}") {
                contentType(ContentType.Application.Json)
                if (refresh) url { parameter("refresh", "true") }
                headers {
                    append(HttpHeaders.Authorization, "Bearer $token")
                }
                accept(ContentType.Application.Json)
            }

            return when (response.status) {
                HttpStatusCode.OK,
                HttpStatusCode.BadRequest -> {
                    response.body<List<Generate>>()
                }
                HttpStatusCode.Unauthorized -> {
                    null
                }
                else ->
                    emptyList()
            }

        } catch (e: Exception) {
            emptyList()
        }
    }
}